import type { FaireProductEntity } from "../../entity_types/product";

export const p_whvbx696kg: FaireProductEntity = {
  token: "p_whvbx696kg",
  type: "product",
  name: "Floral Print & Lace Baby Girl Romper (Organic)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/0af0258f706726ddcda13a4110acf90c1d72699de0f443fd3e3225e9067fea95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47ba64ffbb3ace5fb0e9958695893fe1d3e0f517b65ab4d647595c9215d9571b.jpeg",
    "https://cdn.faire.com/fastly/5c9cc50ece33b7b89ced2faa0589a696a40949c0809faee2baee637ad8b11721.jpeg",
    "https://cdn.faire.com/fastly/c72417810eca33795251079db5f086dfd3c32f759a81c5439c359fa3f7bee25f.jpeg",
    "https://cdn.faire.com/fastly/274b029344e5626e8b62f15bed70d0fb6f0127fe95e3d63ff8d921eaa5a7f02f.jpeg",
    "https://cdn.faire.com/fastly/485e8a28cd75c27e4a6975f8343d901902d58b4d503c843cce0d194edb2266e3.jpeg",
    "https://cdn.faire.com/fastly/bccc225155d8ef79a17c0a8f618294c286319ed4b36aa870059eeada42875619.jpeg",
    "https://cdn.faire.com/fastly/bec0ca0e5fac1488562af05146a3ea7ccaca5428358453ff21874fef3e16afa0.jpeg",
  ],
  priceDollars: 22,
  description:
    "Long sleeve baby romper in printed floral cotton and lace detail.\n\n• Headband sold separately: SKU 247147\n• All-season, lightweight and breathable organic cotton, comfy and cozy.\n• Machine washable, durable and long lasting.\n• Eco-friendly, chemical free, non-toxic, pure, natural & organic baby clothes.\n• Ethically produced in India, supporting better livelihoods for small grower farmers.\n\nViverano, an American brand, was founded in 2013 with the simple idea of producing eco-friendly, pure and organic baby clothes. Viverano baby clothing is known for its soft hand feel and high quality. Pamper your precious babies with our non-toxic, lightweight, all-season, natural baby outfits.\n\nExperience 'Organic Comfort' by Viverano, a family-owned small business.",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:05:01.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
